import { useMemo } from 'react'

/**
 * Hook for extracting unique values from an array of objects.
 * @param data - Array of objects from which we want to extract unique values
 * @param dataIndex - Key by which we want to extract values
 * @returns Array of unique values sorted alphabetically
 */
export function useUniqueValues<T>(data: T[], dataIndex: keyof T): string[] {
  return useMemo(() => {
    if (!data || !data.length) return []
    const uniqueValues = new Set<string>()
    data.forEach(item => {
      const value = item[dataIndex]
      if (value !== undefined && value !== null) {
        uniqueValues.add(String(value))
      }
    })
    return Array.from(uniqueValues).sort()
  }, [data, dataIndex])
}
